import { render, staticRenderFns } from "./ipasasFaPermissionsForm.vue?vue&type=template&id=147b0da2&scoped=true&"
import script from "./ipasasFaPermissionsForm.vue?vue&type=script&lang=js&"
export * from "./ipasasFaPermissionsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147b0da2",
  null
  
)

export default component.exports